import { languageService } from "../../../../Language/language.service";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { TableCellScrollable } from "../../Helper/TableUtils";
import React from "react";

export const complianceIssuesTableSchema = [
  {
    Header: languageService("Start Date & Time"),
    id: "startDate",
    accessor: "startDate",
    Cell: (d) => dataFormatters.dateTimeFormatterWithTimezone(d.value, d.original.timezone, true),
    minWidth: 200,
  },
  {
    Header: languageService("End Date & Time"),
    id: "endDate",
    accessor: "endDate",
    Cell: (d) => dataFormatters.dateTimeFormatterWithTimezone(d.value, d.original.timezone, true),
    minWidth: 200,
  },
  {
    Header: languageService("Violation"),
    accessor: languageService("issueText"),
    id: "issueText",
    minWidth: 400,
    Cell: TableCellScrollable,
  },
];

export const complianceIssuesWithReasonTableSchema = [
  ...complianceIssuesTableSchema,
  {
    Header: languageService("Reason"),
    accessor: "reason",
    id: "reason",
    minWidth: 400,
    Cell: TableCellScrollable,
  },
];



// WEBPACK FOOTER //
// ./src/components/HoursOfService/MyHoursOfService/schemas/complianceIssuesTableSchema.js